import { all } from 'redux-saga/effects';

import configurationSaga from './configuration/sagas';
import fundingSearchOverviewSaga from './fundingSearchOverview/sagas';
import totalApprovedSaga from './totalApproved/sagas';
import searchesRequiringAttentionSaga from './searchesRequiringAttention/sagas';
import leadsOverviewSaga from './leadsOverview/sagas';
import responseTimeSaga from './responseTime/sagas';
import casesSummarySaga from './casesSummary/sagas';
import latestCasesSaga from './latestCases/sagas';
import activitiesSaga from './activities/sagas';
import actionsSaga from './actions/sagas';

export default function* dashboardSaga() {
  return yield all([
    configurationSaga(),
    fundingSearchOverviewSaga(),
    totalApprovedSaga(),
    searchesRequiringAttentionSaga(),
    leadsOverviewSaga(),
    responseTimeSaga(),
    casesSummarySaga(),
    latestCasesSaga(),
    activitiesSaga(),
    actionsSaga(),
  ]);
}
